/**
 * 게시판 관리 (/adm/board) — 동작은 공용 $j.F.Admin.BoardMaster (글관리 화면 모달과 같은 파셜)
 * ($j.Pages.Admin.BoardMaster / body data-page-name="BoardMaster")
 */
export default class BoardMaster {
    initialize() {
        $j.F.Admin.BoardMaster.init();
    }
}
